import PropTypes from "prop-types"
import styles from "../HowToWork.module.scss"

export function StatusTable({ rows }) {
    return (
        <div className={styles.tableWrap}>
            <table className={styles.table}>
                <tbody>
                    {rows.map((r, i) => (
                        <tr key={i}>
                            <td className={styles.textSemibold}>{r.status}</td>
                            <td>{r.desc}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

StatusTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            status: PropTypes.string.isRequired,
            desc: PropTypes.string.isRequired,
        }),
    ).isRequired,
}

export const CHECK_STATUSES = [
    {
        status: "Принят",
        desc: "Чек обработан, баллы за него начислены",
    },
    {
        status: "Требует проверки",
        desc: "По какой‑либо причине чек не был проверен через систему автоматической проверки чеков ОФД. Мы обязательно проверим его вручную, срок проверки до 3 рабочих дней",
    },
    {
        status: "Отклонён, дубликат",
        desc: "Чек уже был ранее загружен в систему",
    },
    {
        status: "Отклонён, не видны товары в чеке, перезагрузите чек",
        desc: "Фото плохого качества, его не получилось обработать через ОФД или вручную",
    },
    {
        status: "Отклонён, товары не участвуют в акции",
        desc: "В чеке нет продукции ZIC, которая участвует в Мотивационной программе",
    },
]

export const ORDER_STATUSES = [
    {
        status: "На проверке Дистрибьютором",
        desc: "Документ на проверке у Дистрибьютора",
    },
    {
        status: "Подтвержден Дистрибьютором",
        desc: "Документ проверен Дистрибьютором, ожидается финализация и начисление баллов",
    },
    {
        status: "Подтвержден, баллы начислены",
        desc: "Заказ-наряд подтвержден",
    },
    {
        status: "Отклонен",
        desc: "С указанием причины (дубликат или некорректные данные)",
    },
]
